
import {Component, Vue} from 'vue-property-decorator';
import ClienteService from "@/service/cliente.service";
import AcompanhamentoModel from "@/models/cliente/acompanhamento.model";
import {namespace} from "vuex-class";
import {MapActionsLoading} from "@/store/modules/loading/map-actions.loading";

const loading = namespace('loading');

@Component({
  name: "acompanhamento-component"
})
export default class AcompanhamentoComponent extends Vue {

  @loading.Action(MapActionsLoading.OPEN_LOADING) openLoading;
  @loading.Action(MapActionsLoading.CLOSE_LOADING) closeLoading;

  private idCliente: number | null = null;
  private acompanhamentos: Array<AcompanhamentoModel> = [];

  formataTipoAcao(tipo: string) {
    if (tipo === 'U') {
      return 'UPDATE';
    } else if (tipo === 'C') {
      return 'CREATE';
    } else {
      return 'DELETE';
    }
  }

  formataData(dateTime: string) {
    const hora = dateTime.substring(11, 19);
    const [year, month, day] = dateTime.substring(0, 10).split('-');
    return `${day}/${month}/${year} ${hora}`;
  }

  async mounted() {
    const idCliente: any = this.$route.params.id;
    if (idCliente) {
      if (this.$route.name === 'ClienteAcompanhamento') {
        this.openLoading();
      }
      this.idCliente = idCliente;
      this.acompanhamentos = await ClienteService.buscarAcompanhamento(this.idCliente);
      this.closeLoading();
    }
  }

}
